import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/takeUntil';

const ANCHOR = {fragment: 'employee-services', tab: 'employee-clothing', selector: '#employee-services',
  busy: 'aria-busy', waiting: 'true', renderDelay: 0, empty: '', initialGeneration: 0, separator: '/'};

@Directive({selector: '[appEmployeeServiceAnchor]', exportAs: 'employeeServiceAnchor'})
export class EmployeeServiceAnchorDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input() serviceEmployeeId: string;
  private initialized = false;
  private pending = false;
  private disposed = false;
  private generation = ANCHOR.initialGeneration;
  private requestedKey = ANCHOR.empty;
  private tabTask: Subscription;
  private focusTask: Subscription;
  private destroyed = new Subject<void>();
  constructor(private route: ActivatedRoute, private tabs: NgbTabset, private host: ElementRef) {}
  ngAfterViewInit(): void {
    this.initialized = true;
    this.route.fragment.takeUntil(this.destroyed).subscribe(fragment => this.request(fragment));
  }
  ngOnChanges(): void { if (this.initialized) { this.request(this.route.snapshot.fragment); } }
  ngOnDestroy(): void {
    this.disposed = true; this.generation++; this.cancelTasks(); this.destroyed.next(); this.destroyed.complete();
  }
  ready(): void {
    if (!this.pending || this.disposed) { return; }
    if (this.tabs.activeId !== ANCHOR.tab) { this.tabs.select(ANCHOR.tab); }
    this.scheduleFocus(true);
  }
  private request(fragment: string): void {
    const key = this.serviceEmployeeId + ANCHOR.separator + (fragment || ANCHOR.empty);
    if (this.disposed || key === this.requestedKey) { return; }
    this.requestedKey = key; this.cancelTasks(); this.generation++;
    this.pending = !!this.serviceEmployeeId && fragment === ANCHOR.fragment;
    if (!this.pending) { return; }
    const generation = this.generation;
    this.tabTask = Observable.timer(ANCHOR.renderDelay).takeUntil(this.destroyed).subscribe(() => {
      if (!this.current(generation)) { return; }
      this.tabs.select(ANCHOR.tab); this.scheduleFocus(false);
    });
  }
  private scheduleFocus(settled: boolean): void {
    if (this.focusTask) { this.focusTask.unsubscribe(); }
    const generation = this.generation;
    this.focusTask = Observable.timer(ANCHOR.renderDelay).takeUntil(this.destroyed).subscribe(() => {
      if (!this.current(generation) || this.tabs.activeId !== ANCHOR.tab) { return; }
      const section = this.host.nativeElement.querySelector(ANCHOR.selector) as HTMLElement;
      if (!section || section.getAttribute(ANCHOR.busy) === ANCHOR.waiting) {
        if (settled) { this.pending = false; }
        return;
      }
      this.pending = false; section.focus(); section.scrollIntoView();
    });
  }
  private current(generation: number): boolean { return !this.disposed && this.pending && generation === this.generation; }
  private cancelTasks(): void {
    if (this.tabTask) { this.tabTask.unsubscribe(); }
    if (this.focusTask) { this.focusTask.unsubscribe(); }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/employee-service-anchor.directive.ts